export { getPaymentMethod } from './PayItForwardHelper'
